import { Meeting } from '../../models/chat';

(function () {
    class PublicChatFeed {
        public publicMeeting: Meeting = {
            id: 0,
            type: 'community',
            name: 'Public Chat',
            entry: '',
            newMessageCount: 0,
            missedCallsCount: 0,
            participants: {},
            thumbnail_url: '',
            unread_count: 0,
            missed_calls_count: 0,
            video_conference_url: '',
        };
    }

    angular.module('tradersyard').component('tyPublicChatFeed', {
        // language=HTML
        template: `
            <div class="chat">
                <ty-chat-conversation conversation="$ctrl.publicMeeting" show-header="false"/>
            </div>
        `,
        controller: PublicChatFeed,
    });
})();
